import { render, staticRenderFns } from "./editarUsuarioModal.vue?vue&type=template&id=3b8fa8dd"
import script from "./editarUsuarioModal.vue?vue&type=script&lang=js"
export * from "./editarUsuarioModal.vue?vue&type=script&lang=js"
import style0 from "./editarUsuarioModal.vue?vue&type=style&index=0&id=3b8fa8dd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports